import { Flow_0_0_2 } from '@flexus/core';

export const BET_78: Flow_0_0_2 = {
	id: '78',
	name: 'awaiting_payment',
	itemType: 'flow',
	header: {
		title: '',
		controls: () => () => []
	},
	footer: {
		type: 'node_nav'
	},
	instructions: {
		editRoles: {
			0: '--'
		},
		viewRoles: {
			0: 'Awaiting payment'
		}
	},
	startNode: '',
	nodes: {}
};
